import ProfileEditableTable from 'pages/profile/components/ProfileTabContent/components/ProfileEditableTable';
import ProfileSection from 'pages/profile/components/ProfileTabContent/components/ProfileSection';
import classes from './index.module.scss';
import useResidentDetails from '../../../../../../hooks/requests/resident/useResidentDetails';
import {
  formatDateMMMMDDYYYY,
  formatSumMoney,
} from '../../../../../../utils/formatters';
import { getResidentProfileData } from './utils';

const ResidentProfile = () => {
  const { residentDetails } = useResidentDetails();
  const unpaidRentPayment = residentDetails?.activeLease?.unpaidRentPayment;

  const filterRentPayment = unpaidRentPayment?.filter(
    (unpaidRentPayment) => unpaidRentPayment.status !== 'paid'
  )[0];

  return (
    <ProfileSection
      title={'Resident profile'}
      titlesClassName={classes.title}
    >
      {filterRentPayment ? (
        <ProfileEditableTable
          data={getResidentProfileData(
            formatDateMMMMDDYYYY(filterRentPayment?.dateDue || ''),
            formatSumMoney(filterRentPayment?.amount || '')
          )}
        />
      ) : (
        <></>
      )}
    </ProfileSection>
  );
};

export default ResidentProfile;
